export enum KeyStr {
  'acct_id' = 'Account ID',
  'acct_name' = 'Account Name',
  'created_at' = 'Creation Date',
  'customer_number' = 'SF Customer Number',
  'expires_at' = 'Expiration Date',
  'id' = 'Id',
  'key_creator_email' = 'Key Creator Email',
  'key_creator_name' = 'Key Creator Name',
  'key_creator_preferred_username' = 'Key Creator Preferred Username',
  'key_creator_sub' = 'Key Creator OIDC Subject',
  'name' = 'KeyName',
}
